<template>
    <div class="billing-info box">
        <div class="box-title">
            Billing Information
        </div>
        <div class="box-content">
            <form
                id="billing-information"
                class="billing-information"
                novalidate
                @submit.prevent="saveInfo"
            >
                <div class="field flex">
                    <div class="field-title">
                        Invoice Data
                    </div>
                    <div class="input">
                        <textarea
                            v-model="billingInfo"
                            @click="clearError()"
                        />
                        <span
                            v-if="billingInfoErrorMessage"
                            class="form-error"
                        >
                            {{ billingInfoErrorMessage }}
                        </span>
                        <label>Additional invoice information ie. your business address and VAT number.</label>
                    </div><!-- .input -->
                </div><!-- .field -->
                <div class="controll-container flex">
                    <base-form-button
                        class="btn"
                        :loading="formProcessing"
                    >
                        Save Changes
                    </base-form-button>
                </div><!-- .controll-container -->
            </form>
        </div><!-- .box-content -->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import toasts from '@/mixins/toasts';

export default {
    mixins: [toasts],

    data: () => ({
        formProcessing: false,
        billingInfo: '',
        billingInfoErrorMessage: null,
    }),

    computed: {
        ...mapState(['user']),
    },

    /**
     * Created hook
     */
    created() {
        this.billingInfo = this.user.meta_data.billing_information;
    },

    methods: {
        ...mapActions(['setUserMeta']),

        /**
         * Validates input data
         *
         * @returns {boolean} Wether data is valid.
         */
        validate() {
            if (! this.billingInfo) {
                this.billingInfoErrorMessage = 'Please enter Billing Information';
                return false;
            }

            return true;
        },

        /**
         * Clears error message
         *
         */
        clearError() {
            this.billingInfoErrorMessage = null;
        },

        /**
         * Save information
         *
         */
        async saveInfo() {
            if (! this.validate()) {
                return;
            }

            this.formProcessing = true;

            try {
                await this.setUserMeta({ billing_information: this.billingInfo });

                this.toastSuccess({
                    message: {
                        title: 'Your Billing Information has been changed!',
                    },
                });
            } catch (e) {
                this.billingInfoErrorMessage = 'We couldn\'t update your Billing Information. Please contact us or try again later';
            }

            this.formProcessing = false;
        },
    },

};
</script>
